import { useEffect, useState } from "react";

interface Props {
  activate: boolean;
  initialTime?: number;
}

export const useCountdown = ({ activate, initialTime = 900 }: Props) => {
  const [timeLeft, setTimeLeft] = useState<number>(initialTime);
  const [isRunning] = useState<boolean>(true);

  useEffect(() => {
    if (!activate) return;

    let timerId: ReturnType<typeof setInterval>;

    if (isRunning && timeLeft >= 0) {
      timerId = setInterval(() => {
        setTimeLeft((prevTime) => prevTime - 1);
      }, 1000);
    } else if (timeLeft <= 0) {
      setTimeLeft(initialTime);
    }

    return () => clearInterval(timerId);
  }, [activate, initialTime, isRunning, timeLeft]);

  const formatTime = (seconds: number) => {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;

    return `${minutes.toString().padStart(2, "0")}:${remainingSeconds
      .toString()
      .padStart(2, "0")}`;
  };

  return formatTime(timeLeft);
};
